import { Action, Reducer } from "redux";
import { SupplierState, SupplierTypes, SupplierActionTypes } from "./supplierTypes";

export const INITIAL_STATE: SupplierState = {
	suppliers: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const supplierReducer: Reducer<SupplierState> = (state: SupplierState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as SupplierActionTypes;
	switch (actionTypes.type) {
		case SupplierTypes.GET_SUPPLIERS:
			return {
				...state,
				suppliers: { ...state.suppliers, isLoading: true },
			};
		case SupplierTypes.SAVE_SUPPLIERS:
			return {
				...state,
				suppliers: {
					...state.suppliers,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case SupplierTypes.RESET_REDUCER_SUPPLIERS:
			return {
				...state,
				suppliers: INITIAL_STATE.suppliers,
			};
		default:
			return state;
	}
};

export default supplierReducer;
